import { Url } from 'next/dist/shared/lib/router/router'
import { useRouter } from 'next/router'
import * as React from 'react'

import { cn } from '@/utils/tw-helpers'

import IconLeft from '@/assets/icons/ic_logic-g-app_arrow-left.svg'

export interface BackButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  backUrl?: string | Url
  icon?: React.ComponentType<{ width?: number; className?: string }>
  iconWidth?: number
  onClick?: () => void

  // Screen reader text. Defaults to "戻る".
  ariaLabel?: string

  // Default fallback behavior when neither onClick nor backUrl is provided.
  // Defaults to router.back()
  defaultFallback?: () => void
}

export const BackButton = React.forwardRef<HTMLButtonElement, BackButtonProps>(
  (
    {
      className,
      backUrl,
      icon: Icon = IconLeft,
      iconWidth = 30,
      ariaLabel = '戻る',
      onClick,
      defaultFallback,
      ...props
    },
    ref
  ) => {
    const router = useRouter()

    const handleClick = () => {
      if (onClick) {
        onClick()
        return
      }

      if (backUrl) {
        router.push(backUrl)
        return
      }

      if (defaultFallback) {
        defaultFallback()
        return
      }

      router.back()
    }

    return (
      <button
        ref={ref}
        className={cn(
          'inline-flex h-10 w-10 items-center justify-center rounded-[4px] text-primary-100',
          'active:bg-[#E2E4E8]',
          className
        )}
        onClick={handleClick}
        aria-label={ariaLabel}
        {...props}
      >
        <Icon width={iconWidth} />
        <span className="sr-only">{ariaLabel}</span>
      </button>
    )
  }
)
BackButton.displayName = 'BackButton'
